
import React, { useEffect } from 'react'
import algoliasearch from 'algoliasearch/lite'
import { useSelector, useDispatch } from 'react-redux'
import { InstantSearch, Configure, connectStats } from 'react-instantsearch-dom'
import { saveSearchState } from '../../store/actions'
import { Link } from 'gatsby'

import PushContent from '../pushContent'
import CustomHits from '../newsroom/customHits'
import SearchActions from '../newsroom/searchActions'
import CustomPagination from '../search/pagination'
import EventCard from '../cards/eventCard'
import DocCard from '../cards/docCard'
import SocialCard from '../cards/socialCard'
import BlogCard from '../cards/blogCard'

import transformLink from '../../utils/transformLink'
import trads from '../../intl/trads.json'

const List = ({data, type, profileFilter, page, furtherContent = null, lang: propLang, seoItems = [], currentUrl = ''}) => {
  const dispatch = useDispatch()
  const storeLang = useSelector(state => state.lang)
  const lang = propLang || storeLang

  const savedSearchState = useSelector(state => state.savedSearchState)
  const searchClient = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY_SEARCH)     

  let filters, typeKey
  let indexName = process.env.GATSBY_ALGOLIA_INDEX_DESC

  useEffect(() => {
    setTimeout(() => {
      const isFromBackButton = sessionStorage.getItem('prevUrl').includes(window.location.href) && sessionStorage.getItem('prevUrl') !== window.location.href
      if (!isFromBackButton) {
        dispatch(saveSearchState({}))
      } else {
        const currentPage = savedSearchState.page
        
        setTimeout(() => {
          dispatch(saveSearchState({...savedSearchState, page: currentPage}))
        }, 0)
      }
    }, 0)
  /* eslint-disable-next-line */
  }, [dispatch])

  switch(type) {
    case 'Événements':
      typeKey = 'events'
      indexName = process.env.GATSBY_ALGOLIA_INDEX_ASC
      filters = `node_locale:${lang} AND contentType:event AND isFuture=1 AND distributionChannel:"Terega solutions"`
      break
    case 'Publications':
      typeKey = 'document'
      filters = `node_locale:${lang} AND contentType:doc AND distributionChannel:"Terega solutions"`
      break
    case 'Communiqués de presse':
      typeKey = 'press'
      filters = `node_locale:${lang} AND contentType:news AND hasPressRelease=1 AND distributionChannel:"Terega solutions"`
      break
    case 'Actualités':
      typeKey = 'news'
      filters = `node_locale:${lang} OR node_locale:both AND contentType:news OR contentType:socials AND distributionChannel:"Terega solutions"`
      break
    case 'Blog':
        typeKey = 'blog'
        filters = `node_locale:${lang} AND contentType:page AND customType:"Blog" AND distributionChannel:"Terega solutions"`
        break
    default:
      filters = null
  }

  return (
    <>
      <div className="newsroom search-container-wrapper">
        <InstantSearch
          searchClient={searchClient}
          indexName={indexName}
          onSearchStateChange={searchState => {
            dispatch(saveSearchState(searchState))
          }}
          searchState={savedSearchState}
        >
          <Configure 
            hitsPerPage={(typeof window !== 'undefined' && window.innerWidth >= 768) ? 12 : 6}
            filters={filters}/>
          <div className="row lg:pt-23">
            <div className="col-12 lg-col-3">
              <SearchActions
                type={typeKey} />
            </div>

            <div className="col-12 lg-col-9 search-actions-content">
              <CustomStats 
                singular={trads[lang].newsroom.stats[typeKey].singular}
                plural={trads[lang].newsroom.stats[typeKey].plural} />
              
              <CustomHits type={typeKey} />
              <CustomPagination forcedPage={page} />
            </div>
          </div>
        </InstantSearch>
      </div>
      
      <PushContent data={data.pushPages} autoItems={furtherContent} />

      <div className="sr-only" aria-hidden="true">
        {seoItems.slice((page - 1) * 12, page * 12).map((item, i) => {
          switch (type) {
            case 'Événements':
              return <EventCard event={item} key={i} />
            case 'Publications':
              return <DocCard document={item} key={i} />
            case 'Communiqués de presse':
              return <DocCard document={item} isPressRelease={true} key={i} />
            case 'Actualités':
              return (
                <React.Fragment key={i}>
                  {item.title ? (
                    <Link to={transformLink(item, false, false).url || '#'}>{item.title}</Link>
                  ) : (
                    <SocialCard social={item} seo={true} />
                  )}
                </React.Fragment>
              )
            case 'Blog':
              return <BlogCard blog={item} key={i} />
            default:
              return null
          }
        })}
        {(() => {
          const nbPages = Math.ceil(seoItems.length / 12)
          return Array.from(Array(nbPages)).map((_, i) => (
            <Link key={`page-${i}`} to={`${currentUrl}${i > 0 ? `/page/${i + 1}` : ''}`}>
              {i + 1}
            </Link>
          ))
        })()}
      </div>
    </>
  )
}

// custom stats
const Stats = ({ processingTimeMS, nbHits, singular, plural }) => (
  <h2 className="title title-slice mb-5 md:mb-7">
    {nbHits} {(nbHits > 1) ? plural : singular}
  </h2>
)

const CustomStats = connectStats(Stats)

export default List